import type {MessageTree} from "@jantm/model-core";

export const nl: MessageTree = {
  model: { car: { field: { licensePlate: 'Kenteken' } } },
}
